import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { NzUploadFile } from 'ng-zorro-antd/upload';

interface ResGetActiveTeacher {
  message: string;
  result: {
    ACTIVE_USER: number;
    DATE_OF_BIRTH: Date;
    EMAIL: string;
    GENDER: string;
    PASSWORD: string;
    PERSONAL_DESCRIPTION: string;
    PHONENUMBER: string;
    PROFILE_PIC: string;
    REGISTER_DATE: Date;
    TEACHER_ID: string;
    USERNAME: string;
  };
  success: boolean;
}

interface ResGetAllTypeCourse {
  message: string;
  result: [
    {
      COURSE_TYPE_NAME: string;
      ID: string;
    }
  ];
  success: boolean;
}

interface ResGetSuggestCourse {
  message: string;
  result: [
    {
      COURSE_COIN_CLOSE: number;
      COURSE_COIN_REWARD: number;
      COURSE_CREATE: Date;
      COURSE_DESCRIPTION: string;
      COURSE_END: Date;
      COURSE_ID: string;
      COURSE_NAME: string;
      COURSE_PIC: string;
      COURSE_PRICE: number;
      COURSE_RECOMMEND: string;
      COURSE_SPECIALPRICE: number;
      COURSE_START: Date;
      COURSE_STATUS: number;
      COURSE_TYPE: string;
      COURSE_VDO: string;
      TEACHER_ID: string;
    }
  ];
  success: boolean;
}

interface ResGetAllCourse {
  message: string;
  result: [
    {
      ADMIN: [
        {
          COURSE_ID: string;
          TEACHER_ID: string;
          USERNAME: string;
        }
      ];
      COURSE_CREATE: Date;
      COURSE_ID: string;
      COURSE_NAME: string;
      COURSE_PRICE: number;
      COURSE_STATUS: number;
      COURSE_START: Date;
      COURSE_END: Date;
      TEACHER_ID: string;
      USERNAME: string;
      COURSE_TYPE_NAME: string;
      ID: string;
      MESSAGE_ALERT: number,
      COURSE_NUMBER: string,
    }
  ];
  success: boolean;
}

interface ResCreateCourse {
  message: string;
  result: {
    COURSE_ID: string;
  }
  success: boolean;
}

interface ResCreateLesson {
  message: string;
  result: {
    LESSON_ID: string;
  }
  success: boolean;
}

interface ResCreateAssignment {
  message: string;
  result: {
    ASSIGNMENT_ID: string;
    ASSIGNMENT_NAME: string;
    ASSIGNMENT_PIC: File;
    ASSIGNMENT_PIC_ORIGINAL: File;
    COURSE_ID: string;
    CREATE_DATE: Date;
    LESSON_ID: string;
    TIME_SHOW: string;
    UPDATE_DATE: Date;
  }
  success: boolean;
}

interface ResGetLessonDetailByCourseId {
  message: string;
  result: [{
    LESSON_DOC: string;
    LESSON_ID: string;
    LESSON_NAME: string;
    TOPIC: [
      {
        TOPIC_ID: string;
        TOPIC_LINE: number;
        TOPIC_NAME: string;
        TOPIC_TYPE: string;
      }
    ]
  }]
  success: boolean;
}

interface ResGetDetailByTopic {
  message: string;
  result: {
    PASSOFQUIZ: number;
    TIME_QUIZ_AGAIN: number;
    TOPIC_ID: string;
    TOPIC_NAME: string;
    VALUE: [
      {
        QUESTION: string;
        VALUE: [
          {
            ID_TRANS: number;
            OPTION_ID: number;
            OPTION_NAME: string;
            OPTION_NUMBER: number;
            OPTION_PIC: string;
            OPTION_PIC_ORIGINAL: string;
          }
        ]
      }
    ]
  }
  success: boolean;
}

interface ResDelTopicById {
  message: string;
  result: {
    updatetime: Date;
  }
  success: boolean;
}

interface ResDelCourseById {
  message: string;
  result: {
    update: Date;
  }
  success: boolean;
}

interface ResGetAllMeasure {
  message: string;
  result: [{
    MEASURE_ID: string;
    MEASURE_NAME: string;
  }]
  success: boolean;
}

interface ResCreateVideoCourse {
  message: string;
  result: {
    VIDEO_COURSE_ID: string;
  }
  success: boolean;
}

interface ResEditVideoById {
  message: string;
  result: {
    updatetime: Date;
  }
  success: boolean;
}

interface ResGetDetailCourseById {
  message: string;
  result: [
    {
      ADMIN: [
        {
          COURSE_ID: string;
          TEACHER_ID: string;
          USERNAME: string;
        }
      ]
      COURSE_COIN_CLOSE: number;
      COURSE_COIN_REWARD: number;
      COURSE_CREATE: Date;
      COURSE_DESCRIPTION: string;
      COURSE_END: Date;
      COURSE_ID: string;
      COURSE_NAME: string;
      COURSE_PIC: string;
      COURSE_PIC_ORIGINAL: string;
      COURSE_PRICE: number;
      COURSE_RECOMMEND: string;
      COURSE_SPECIALPRICE: number;
      COURSE_START: Date;
      COURSE_STATUS: number;
      COURSE_SUGGESTION: [
        {
          COURSE_ID: string;
          COURSE_SUGGEST_ID: string;
          ID: number;
          COURSE_NAME: string;
        }
      ]
      COURSE_TYPE_NAME: string;
      COURSE_VDO_EXAMPLE: string;
      COURSE_VDO_EXAMPLE_NAME: string;
      TEACHER_ID: string;
      USERNAME: string;
    }
  ]
  success: boolean;
}

interface ResGetAllReceiveAssignmentById {
  success: boolean;
  message: string;
  result: [
    {
      ASSIGNMENT_ID: string;
      COURSE_ID: string;
      LESSON_ID: string;
      TIME_SHOW: number;
      CREATE_DATE: Date;
      UPDATE_DATE: Date;
      ASSIGNMENT_PIC: string;
      ASSIGNMENT_PIC_ORIGINAL: string;
      ASSIGNMENT_NAME: string;
      LINE: string;
      COURSE_NAME: string;
      COURSE_NUMBER: string;
      WAIT_FEEDBACK: number;
    }
  ]
}

interface ResGetDetailReceiveAssignmentById {
  success: boolean;
  message: string;
  result: [
    {
      ASSIGNMENT_NAME: string;
      COURSE_ID: string;
      COURSE_NAME: string;
      DETAIL: [{
        FEEDBACK_ID: string;
        ASSIGNMENT_ID: string;
        FEEDBACK_DOC: string;
        FEEDBACK_DOC_ORIGINAL: string;
        SENDER_ID: string;
        SENDER_TYPE: string;
        FEEDBACK_MESSAGE: string;
        CREATE_DATE: Date;
        UPDATE_DATE: Date;
        TO_FEEDBACK_ID: string;
        FORM_FEEDBACK_ID: string;
        COURSE_ID: string;
        COURSE_NAME: string;
        ASSIGNMENT_NAME: string;
        USERNAME: string;
        USER_ID: string;
        CanFeedBack: boolean;
      }
      ]
    }
  ]
}

interface ResCallBackReceiveAssignmentById {
  success: boolean;
  message: string;
  result: [
    {
      ASSIGNMENT_ID: string;
      FEEDBACK_MESSAGE: string;
      FEEDBACK_DOC: string;
      FROM_FEEDBACK_ID: string;
    }
  ]
}
interface ResValidateCourseNumber {
  message: string;
  result: {
    COURSE_NUMBER: string;
  }
  success: boolean;
}

interface ResSaveDraftCourse {
  message: string;
  result: [{
    update: Date;
  }]
  success: boolean;
}

interface ResGetAllReviewByCourseId {
  success: boolean,
  message: string,
  result: {
    CAN_POST: boolean,
    POINT: {
      TOTAL_REVIEW: number,
      MAX_POINT: number,
      AVERAGE_POINT: number
    },
    REVIEW_LIST: [
      {
        REVIEW_ID: string,
        REVIEW_MESSAGE: string,
        REVIEW_DATE: string,
        REVIEW_POINT: number,
        USERNAME: string,
        IMAGE_PROFILE: string
      }
    ]
  }
}

interface ResDelReviewById {
  [x: string]: any;
  REVIEW_ID: string;
}

interface ResGetDetailSendedAssignmentById {
  success: boolean,
  message: string,
  result: [
    {
      ASSIGNMENT_NAME: string;
      COURSE_ID: string;
      COURSE_NAME: string;
      DETAIL: [{
        FEEDBACK_ID: string,
        ASSIGNMENT_ID: string,
        FEEDBACK_DOC: string,
        FEEDBACK_DOC_ORIGINAL: string,
        SENDER_ID: string,
        SENDER_TYPE: string,
        FEEDBACK_MESSAGE: string,
        CREATE_DATE: Date,
        UPDATE_DATE: Date,
        COURSE_ID: string,
        COURSE_NAME: string,
        ASSIGNMENT_NAME: string,
        USERNAME: string,
        USER_ID: string,
        CanFeedBack: false,
        DETAIL_FEEDBACK: [
          {
            FEEDBACK_MESSAGE: string,
            FEEDBACK_DOC_ORIGINAL: string,
            FEEDBACK_DOC: string
          }
        ]
      }]
    }
  ]
}

interface ResGetChatByCourseId {
  success: boolean,
  message: string,
  result:
  {
    COURSE_NAME: string,
    respon: [
      {
        CHAT_ID: string,
        CHAT_NUMBER: number,
        CHAT_MESSAGE: string,
        CHAT_USER_ID: string,
        CHAT_USERNAME: string,
        PROFILE_PIC: string,
        CREATE_DATE: Date,
        SUB_CHAT: [
          {
            CHAT_ID: string,
            CHAT_NUMBER: string,
            CHAT_MESSAGE: string,
            CHAT_USER_ID: string,
            CHAT_USERNAME: string,
            CREATE_DATE: Date,
            PROFILE_PIC: string
          }
        ]
      }
    ]

  }

}

interface ResDelChatById {
  [x: string]: any;
  CHAT_ID: string;
}

interface resPostPrivateChatTA {
  message: string,
  success: boolean,
}

interface resGetAllPrivateChat {
  message: string,
  success: boolean,
  result: [
    {
      ID: number,
      USERNAME: string,
      LAST_MESSAGE: string,
      CHAT_ID: number,
      COUNT_UNREAD: number,
      USER_ID: number,
      COURSE_NAME: string,
    },
  ]
}

interface resGetPrivateChatByUser {
  message: string,
  success: boolean,
  result: [
    {
      ID: number,
      CHAT_ID: number,
      ADMIN_ID: string,
      USER_ID: string,
      MESSAGE_TYPE: string,
      MESSAGE: string
      FILE_NAME: string,
      CREATE_DATE: string,
      USER_TYPE: string
    }
  ]
}

interface resGetActiveUser {
  message: string,
  success: string,
  result: [
    {
      USER_ID: string,
      EMAIL: string
    }
  ]
}

@Injectable({
  providedIn: 'root'
})

export class ELearningManagementService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getActiveTeacher() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetActiveTeacher>(environment.URL + '/manage_admin/getActiveTeacher', { headers: headers });
  }

  getAllTypeCourse() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllTypeCourse>(environment.URL + '/course/getAllTypeCourse', { headers: headers });
  }

  getSuggestCourse() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetSuggestCourse>(environment.URL + '/course/getSuggestCourse', { headers: headers });
  }

  createCourse(c, exampleVdoName, exampleVDOUri) {
    let formData = new FormData;
    let courseSuggest = [];
    let teacherAssistant = [];
    const headers = new HttpHeaders({ Authorization: this.token })

    for (let i = 0; i < c.courseSuggest?.length; i++) {
      courseSuggest.push(c.courseSuggest[i].COURSE_ID);
    }

    for (let i = 0; i < c.teacherAssistant?.length; i++) {
      teacherAssistant.push(c.teacherAssistant[i].TEACHER_ID);
    }

    if (c.courseDateTime[1] !== null) {
      formData.append('ALWAYS_OPEN', JSON.stringify(false));
      formData.append('COURSE_END', c.courseDateTime[1]);
    } else {
      formData.append('ALWAYS_OPEN', JSON.stringify(true));
      formData.append('COURSE_END', '');
    }

    formData.append('COURSE_NAME', c.courseName);
    formData.append('COURSE_NUMBER', c.courseNumber);
    formData.append('COURSE_TYPE_NAME', c.courseType);
    formData.append('TEACHER_ID', c.teacherId);
    formData.append('TEACHER_ASSISTANT', JSON.stringify(teacherAssistant));
    formData.append('COURSE_PIC', c.coursePic);
    formData.append('COURSE_VDO_EXAMPLE', exampleVDOUri);
    formData.append('COURSE_VDO_EXAMPLE_NAME', exampleVdoName);
    formData.append('COURSE_PRICE', c.coursePrice);
    formData.append('COURSE_SPECIALPRICE', c.courseSpacialPrice);
    formData.append('COURSE_COIN_REWARD', c.courseCoinReward);
    formData.append('COURSE_COIN_CLOSE', c.courseCoinClose);
    formData.append('COURSE_START', c.courseDateTime[0]);
    // formData.append('COURSE_END', c.courseDateTime[1]);
    formData.append('COURSE_DESCRIPTION', c.courseDescrition);
    formData.append('COURSE_SUGGESTION', JSON.stringify(courseSuggest));
    formData.append('OPEN_REVIEW', JSON.stringify(c.openReview));
    formData.append('OPEN_CHAT', JSON.stringify(c.openChat));
    formData.append('OPEN_PRIVATECHAT', JSON.stringify(c.openPrivateChat));
    formData.append('TA_ID', JSON.stringify(c.taId));
    formData.append('ACCOUNTING_ID', c.accountId);

    if (c.centerId) {
      if (c.centerId.length > 0) {
        for (let i = 0; i < c.centerId.length; i++) {
          const el = c.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<ResCreateCourse>(environment.URL + '/manage_admin/createCourse', formData, { headers: headers });
  }

  getAllCourse() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllCourse>(environment.URL + '/manage_admin/getAllcourse', { headers: headers });
  }

  getLessonDetailByCourseId(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResGetLessonDetailByCourseId>(environment.URL + '/manage_admin/getLessonDetailByCourseId', body, { headers: headers });
  }


  getDetailByTopic(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResGetDetailByTopic>(environment.URL + '/manage_admin/getDetailByTopic', body, { headers: headers });
  }

  getAllMeasure() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllMeasure>(environment.URL + '/manage_admin/getAllMeasure', { headers: headers });
  }

  createMeasureByCourse(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/manage_admin/createMeasureByCourse', body, { headers: headers });
  }

  editMeasureByCourse(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/manage_admin/editMeasureByCourse', body, { headers: headers });
  }

  createAssignment(body) {
    let formData = new FormData;
    const headers = new HttpHeaders({ Authorization: this.token })
    // console.log(body);

    formData.append('TYPE_CREATE', body.TYPE_CREATE);
    formData.append('COURSE_ID', body.COURSE_ID);
    formData.append('LESSON_ID', body.LESSON_ID);
    formData.append('ASSIGNMENT_DOC', body.ASSIGNMENT_DOC);
    formData.append('TIME_SHOW', JSON.stringify(body.TIME_SHOW));
    formData.append('ASSIGNMENT_NAME', body.ASSIGNMENT_NAME);
    formData.append('LINE', body.LINE);

    return this.http.post<ResCreateAssignment>(environment.URL + '/manage_admin/createAssignment', formData, { headers: headers });
  }

  editAssignmentCourseById(body) {
    let formData = new FormData;
    const headers = new HttpHeaders({ Authorization: this.token })
    // console.log(body);

    if (body.ASSIGNMENT_DOC) {
      formData.append('ASSIGNMENT_DOC', body.ASSIGNMENT_DOC);
    }

    formData.append('ASSIGNMENT_ID', body.TOPIC_ID);
    formData.append('TIME_SHOW', JSON.stringify(body.TIME_SHOW));
    formData.append('ASSIGNMENT_NAME', body.ASSIGNMENT_NAME);

    return this.http.post(environment.URL + '/manage_admin/editAssignmentCourseById', formData, { headers: headers });
  }

  createQuiz(body) {
    let formData = new FormData;
    const headers = new HttpHeaders({ Authorization: this.token })

    // console.log(body);

    for (let i = 0; i < body.OPTION_IMAGE.length; i++) {
      // console.log(body.OPTION_IMAGE[i]);

      formData.append('OPTION_IMAGE', body.OPTION_IMAGE[i]);
    }

    formData.append('TYPE_CREATE', body.TYPE_CREATE);
    formData.append('QUIZ_NAME', body.QUIZ_NAME);
    formData.append('COURSE_ID', body.COURSE_ID);
    formData.append('LESSON_ID', body.LESSON_ID);
    formData.append('TIME_QUIZ_AGAIN', JSON.stringify(body.TIME_QUIZ_AGAIN));
    formData.append('PASSOFQUIZ', JSON.stringify(body.PASSOFQUIZ));
    formData.append('VALUE', JSON.stringify(body.VALUE));
    formData.append('LINE', body.LINE);

    return this.http.post(environment.URL + '/manage_admin/createQuiz', formData, { headers: headers });
  }

  editQuizCourseById(body) {
    let formData = new FormData;
    const headers = new HttpHeaders({ Authorization: this.token })

    // console.log(body);

    for (let i = 0; i < body.OPTION_IMAGE.length; i++) {
      // console.log(body.OPTION_IMAGE[i]);

      formData.append('OPTION_IMAGE', body.OPTION_IMAGE[i]);
    }

    formData.append('QUIZ_ID', body.QUIZ_ID);
    formData.append('QUIZ_NAME', body.QUIZ_NAME);
    formData.append('TIME_QUIZ_AGAIN', JSON.stringify(body.TIME_QUIZ_AGAIN));
    formData.append('PASSOFQUIZ', JSON.stringify(body.PASSOFQUIZ));
    formData.append('VALUE', JSON.stringify(body.VALUE));

    return this.http.post(environment.URL + '/manage_admin/editQuizCourseById', formData, { headers: headers });
  }

  createVideoCourse(body) {
    let formData = new FormData;

    const headers = new HttpHeaders({ Authorization: this.token })

    formData.append('TYPE_CREATE', body.TYPE_CREATE);
    formData.append('COURSE_ID', body.COURSE_ID);
    formData.append('LESSON_ID', body.LESSON_ID);
    formData.append('VIDEO_COURSE_ID', body.VIDEO_COURSE_ID);
    formData.append('VIDEO_NAME', body.VIDEO_NAME);
    formData.append('ORIGINAL_NAME_VDO', body.ORIGINAL_NAME_VDO);
    formData.append('LINE', JSON.stringify(body.LINE));
    formData.append('VIDEO_THUMNAL', body.VIDEO_THUMNAL);
    formData.append('HASH_KEY', body.HASH_KEY)

    return this.http.post<ResCreateVideoCourse>(environment.URL + '/manage_admin/createVideoCourse', formData, { headers: headers });
  }

  editVideoById(body) {
    let formData = new FormData;

    const headers = new HttpHeaders({ Authorization: this.token })

    formData.append('VIDEO_COURSE_ID_NEW', body.VIDEO_COURSE_ID_NEW);
    formData.append('VIDEO_COURSE_ID_OLD', body.VIDEO_COURSE_ID_OLD);
    formData.append('ORIGINAL_NAME_VDO', body.ORIGINAL_NAME_VDO);
    formData.append('VIDEO_NAME', body.VIDEO_NAME);
    formData.append('VIDEO_THUMNAL', body.VIDEO_THUMNAL);
    formData.append('HASH_KEY', body.HASH_KEY)

    return this.http.post<ResEditVideoById>(environment.URL + '/manage_admin/editVideoById', formData, { headers: headers });
  }

  delTopicById(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResDelTopicById>(environment.URL + '/manage_admin/delTopicById', body, { headers: headers });
  }

  delCourseById(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResDelCourseById>(environment.URL + '/manage_admin/delCourseById', body, { headers: headers });
  }

  createLesson(body) {
    let formData = new FormData;
    const headers = new HttpHeaders({ Authorization: this.token })
    // // console.log(body);

    formData.append('LESSON_NAME', body.lesson.LESSON_NAME);
    formData.append('LESSON_DOC', body.lesson.LESSON_DOC);
    formData.append('LESSON_INDEX', body.index);
    formData.append('LESSON_ID', body.lessonId);
    formData.append('COURSE_ID', body.courseId);

    return this.http.post<ResCreateLesson>(environment.URL + '/manage_admin/createLesson', formData, { headers: headers });
  }

  createVideo(file: File | NzUploadFile): Observable<any> {
    const body = {
      name: file.name,
      upload: {
        approach: 'tus',
        size: file.size
      },
      // privacy: {
      //   view: 'unlisted',
      // },
      embed: {
        buttons: {
          embed: false,
          like: false,
          share: false,
          watchlater: false
        },
        logos: {
          vimeo: false
        },
        title: {
          name: 'hide',
          owner: 'hide',
          portrait: 'hide',
        }
      }
    };
    // console.log(file);
    const header: HttpHeaders = new HttpHeaders()
      .set('Authorization', 'bearer ' + environment.VIMEO_ACCESS_TOKEN)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/vnd.vimeo.*+json;version=3.4');

    return this.http.post(environment.VIMEO_API_URL, body, { headers: header, observe: 'response' });
  }

  createVideoLesson(file: File): Observable<any> {
    const body = {
      name: file.name,
      upload: {
        approach: 'tus',
        size: file.size
      },
      privacy: {
        view: 'unlisted',
      },
      embed: {
        buttons: {
          embed: false,
          like: false,
          share: false,
          watchlater: false
        },
        logos: {
          vimeo: false
        },
        title: {
          name: 'hide',
          owner: 'hide',
          portrait: 'hide',
        }
      }
    };
    // console.log(file);
    const header: HttpHeaders = new HttpHeaders()
      .set('Authorization', 'bearer ' + environment.VIMEO_ACCESS_TOKEN)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/vnd.vimeo.*+json;version=3.4');

    return this.http.post(environment.VIMEO_API_URL, body, { headers: header, observe: 'response' });
  }

  getDetailCourseById(courseId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetDetailCourseById>(environment.URL + '/manage_admin/getDetailCourseById?COURSE_ID=' + courseId, { headers: headers });
  }

  saveDraftCourse(c) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;
    let courseSuggest = [];
    let teacherAssistant = [];

    // console.log(c);

    for (let i = 0; i < c.COURSE_SUGGESTION?.length; i++) {
      courseSuggest.push(c.COURSE_SUGGESTION[i].COURSE_ID);
    }

    for (let i = 0; i < c.TEACHER_ASSISTANT?.length; i++) {
      teacherAssistant.push(c.TEACHER_ASSISTANT[i].TEACHER_ID);
    }

    for (let i = 0; i < c.LESSON_DOC?.length; i++) {
      formData.append('LESSON_DOC', c.LESSON_DOC[i].LESSON_DOC);
    }

    for (let i = 0; i < c.LESSON_CREATE_DOC?.length; i++) {
      formData.append('LESSON_DOC', c.LESSON_CREATE_DOC[i].LESSON_DOC);
    }

    if (c.COURSE_END !== null) {
      formData.append('ALWAYS_OPEN', JSON.stringify(false));
    } else {
      formData.append('ALWAYS_OPEN', JSON.stringify(true));
    }

    formData.append('COURSE_ID', c.COURSE_ID);
    formData.append('COURSE_NUMBER', c.COURSE_NUMBER);
    formData.append('COURSE_NAME', c.COURSE_NAME);
    formData.append('COURSE_TYPE_NAME', c.COURSE_TYPE_NAME);
    formData.append('TEACHER_ID', c.TEACHER_ID);
    formData.append('TEACHER_ASSISTANT', JSON.stringify(teacherAssistant));
    formData.append('COURSE_PIC', c.COURSE_PIC);
    formData.append('COURSE_VDO_EXAMPLE_NAME', c.COURSE_VDO_EXAMPLE_NAME);
    formData.append('COURSE_VDO_EXAMPLE', c.COURSE_VDO_EXAMPLE);
    formData.append('COURSE_PRICE', c.COURSE_PRICE);
    formData.append('COURSE_SPECIALPRICE', c.COURSE_SPECIALPRICE);
    formData.append('COURSE_COIN_REWARD', c.COURSE_COIN_REWARD);
    formData.append('COURSE_COIN_CLOSE', c.COURSE_COIN_CLOSE);
    formData.append('COURSE_START', c.COURSE_START);
    formData.append('COURSE_END', c.COURSE_END);
    formData.append('COURSE_DESCRIPTION', c.COURSE_DESCRIPTION);
    formData.append('COURSE_SUGGESTION', JSON.stringify(courseSuggest));
    formData.append('LESSON_EDIT', JSON.stringify(c.LESSON_EDIT));
    formData.append('TYPE_BUTTON', 'draft');
    formData.append('LESSON_DEL', JSON.stringify(c.LESSON_DEL));
    formData.append('LESSON_CREATE', JSON.stringify(c.LESSON_CREATE));
    formData.append('OPEN_REVIEW', JSON.stringify(c.OPEN_REVIEW));
    formData.append('OPEN_CHAT', JSON.stringify(c.OPEN_CHAT));
    formData.append('OPEN_PRIVATECHAT', JSON.stringify(c.OPEN_PRIVATECHAT));
    formData.append('TA_ID', JSON.stringify(c.TA_ID));
    formData.append('ACCOUNTING_ID', c.ACCOUNTING_ID);

    if (c.CENTER_ID) {
      if (c.CENTER_ID.length > 0) {
        for (let i = 0; i < c.CENTER_ID.length; i++) {
          const el = c.CENTER_ID[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<ResSaveDraftCourse>(environment.URL + '/manage_admin/saveDraftCourse', formData, { headers: headers });
  }

  confirmCreateCourse(c) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;
    let courseSuggest = [];
    let teacherAssistant = [];

    // console.log(c);

    for (let i = 0; i < c.COURSE_SUGGESTION?.length; i++) {
      courseSuggest.push(c.COURSE_SUGGESTION[i].COURSE_ID);
    }

    for (let i = 0; i < c.TEACHER_ASSISTANT?.length; i++) {
      teacherAssistant.push(c.TEACHER_ASSISTANT[i].TEACHER_ID);
    }

    for (let i = 0; i < c.LESSON_DOC?.length; i++) {
      formData.append('LESSON_DOC', c.LESSON_DOC[i].LESSON_DOC);
    }

    for (let i = 0; i < c.LESSON_CREATE_DOC?.length; i++) {
      formData.append('LESSON_DOC', c.LESSON_CREATE_DOC[i].LESSON_DOC);
    }

    if (c.COURSE_END !== null) {
      formData.append('ALWAYS_OPEN', JSON.stringify(false));
    } else {
      formData.append('ALWAYS_OPEN', JSON.stringify(true));
    }

    formData.append('COURSE_ID', c.COURSE_ID);
    formData.append('COURSE_NUMBER', c.COURSE_NUMBER);
    formData.append('COURSE_NAME', c.COURSE_NAME);
    formData.append('COURSE_TYPE_NAME', c.COURSE_TYPE_NAME);
    formData.append('TEACHER_ID', c.TEACHER_ID);
    formData.append('TEACHER_ASSISTANT', JSON.stringify(teacherAssistant));
    formData.append('COURSE_PIC', c.COURSE_PIC);
    formData.append('COURSE_VDO_EXAMPLE_NAME', c.COURSE_VDO_EXAMPLE_NAME);
    formData.append('COURSE_VDO_EXAMPLE', c.COURSE_VDO_EXAMPLE);
    formData.append('COURSE_PRICE', c.COURSE_PRICE);
    formData.append('COURSE_SPECIALPRICE', c.COURSE_SPECIALPRICE);
    formData.append('COURSE_COIN_REWARD', c.COURSE_COIN_REWARD);
    formData.append('COURSE_COIN_CLOSE', c.COURSE_COIN_CLOSE);
    formData.append('COURSE_START', c.COURSE_START);
    formData.append('COURSE_END', c.COURSE_END);
    formData.append('COURSE_DESCRIPTION', c.COURSE_DESCRIPTION);
    formData.append('COURSE_SUGGESTION', JSON.stringify(courseSuggest));
    formData.append('LESSON_EDIT', JSON.stringify(c.LESSON_EDIT));
    formData.append('TYPE_BUTTON', 'confirm');
    formData.append('LESSON_DEL', JSON.stringify(c.LESSON_DEL));
    formData.append('LESSON_CREATE', JSON.stringify(c.LESSON_CREATE));
    formData.append('OPEN_REVIEW', JSON.stringify(c.OPEN_REVIEW));
    formData.append('OPEN_CHAT', JSON.stringify(c.OPEN_CHAT));
    formData.append('OPEN_PRIVATECHAT', JSON.stringify(c.OPEN_PRIVATECHAT));
    formData.append('TA_ID', JSON.stringify(c.TA_ID));
    formData.append('ACCOUNTING_ID', c.ACCOUNTING_ID);

    if (c.CENTER_ID) {
      if (c.CENTER_ID.length > 0) {
        for (let i = 0; i < c.CENTER_ID.length; i++) {
          const el = c.CENTER_ID[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<ResSaveDraftCourse>(environment.URL + '/manage_admin/confirmCreateCourse', formData, { headers: headers });
  }

  validateCourseNumber(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResValidateCourseNumber>(environment.URL + '/manage_admin/validateCourseNumber', body, { headers: headers });
  }
  getAllReceiveAssignmentById(courseId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllReceiveAssignmentById>(environment.URL + '/manage_assignment/getAllReceiveAssignmentById?COURSE_ID=' + courseId, { headers: headers });
  }

  getDetailReceiveAssignmentById(assignmentId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetDetailReceiveAssignmentById>(environment.URL + '/manage_assignment/getDetailReceiveAssignmentById?ASSIGNMENT_ID=' + assignmentId, { headers: headers });
  }

  callBackReceiveAssignmentById(feedback) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;

    if (!feedback.FEEDBACK_DOC) {
      formData.append('ASSIGNMENT_ID', feedback.ASSIGNMENT_ID);
      formData.append('FEEDBACK_MESSAGE', feedback.FEEDBACK_MESSAGE);
      formData.append('FROM_FEEDBACK_ID', feedback.FROM_FEEDBACK_ID);
    } else {
      formData.append('ASSIGNMENT_ID', feedback.ASSIGNMENT_ID);
      formData.append('FEEDBACK_MESSAGE', feedback.FEEDBACK_MESSAGE);
      formData.append('FEEDBACK_DOC', feedback.FEEDBACK_DOC);
      formData.append('FROM_FEEDBACK_ID', feedback.FROM_FEEDBACK_ID);
    }


    return this.http.post<ResCallBackReceiveAssignmentById>(environment.URL + '/manage_assignment/callBackReceiveAssignmentById', formData, { headers: headers });
  }

  getAllReviewByCourseId(courseId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllReviewByCourseId>(environment.URL + '/manage_review/getAllReviewByCourseId?COURSE_ID=' + courseId, { headers: headers });
  }

  delReviewById(reviewId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResDelReviewById>(environment.URL + '/manage_review/delReviewById', { REVIEW_ID: reviewId }, { headers: headers });
  }

  getDetailSendedAssignmentById(assignmentId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetDetailSendedAssignmentById>(environment.URL + '/manage_assignment/getDetailSendedAssignmentById?ASSIGNMENT_ID=' + assignmentId, { headers: headers });
  }

  getChatByCourseId(courseId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetChatByCourseId>(environment.URL + '/chat/getChatByCourseId?COURSE_ID=' + courseId, { headers: headers });
  }

  delChatById(chatID) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResDelChatById>(environment.URL + '/chat/delChatById', { CHAT_ID: chatID }, { headers: headers });
  }

  getAllPrivateChat(cid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllPrivateChat>(environment.URL + '/manage_admin/getAllPrivateChat?COURSE_ID=' + cid, { headers: headers });
  }

  getPrivateChatByUser(cid, uid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetPrivateChatByUser>(environment.URL + `/manage_admin/getPrivateChatByUser?COURSE_ID=${cid}&USER_ID=${uid}`, { headers: headers });
  }

  postPrivateChatTA(form, body, cid, uid) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;

    for (let i = 0; i < form.file.fileList?.length; i++) {
      formData.append('IMAGE', form.file.fileList[i].originFileObj);
    }

    formData.append('USER_ID', uid);
    formData.append('COURSE_ID', cid);
    formData.append('CHAT_DATA', JSON.stringify(body));

    return this.http.post<resPostPrivateChatTA>(environment.URL + '/manage_admin/postPrivateChatTA', formData, { headers: headers });
  }

  getActiveUser() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetActiveUser>(environment.URL + '/manage_admin/getActiveUser', { headers: headers });
  }
}

